import { useState } from 'react';
import { Check, ChevronsUpDown, Globe, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSelectedSite } from '../context/SelectedSiteContext';
import { direccionMostrable } from '@/features/builder/site-url';

export const SiteSwitcherDropdown = () => {
  const { sites, selectedSite, selectSite, loading } = useSelectedSite();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  if (loading || sites.length === 0) {
    return (
      <button
        type="button"
        onClick={() => navigate('/agencia/configuracion/sitios')}
        className="inline-flex items-center gap-2 rounded-md border border-dashed border-slate-300 px-3 py-1.5 text-xs font-medium text-slate-600 hover:bg-slate-50"
      >
        <Plus size={14} />
        Crear sitio
      </button>
    );
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-haspopup="listbox"
        className="inline-flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
      >
        <Globe size={16} className="text-blue-600" />
        <span className="max-w-[160px] truncate">
          {selectedSite?.name ?? 'Selecciona sitio'}
        </span>
        <ChevronsUpDown size={14} className="text-slate-400" />
      </button>

      {open && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setOpen(false)}
            aria-hidden
          />
          <ul
            role="listbox"
            className="absolute right-0 z-50 mt-1 max-h-96 w-72 overflow-auto rounded-md border border-slate-200 bg-white py-1 shadow-lg"
          >
            {sites.map((site) => (
              <li key={site.id}>
                <button
                  type="button"
                  role="option"
                  aria-selected={selectedSite?.id === site.id}
                  onClick={() => {
                    selectSite(site.id);
                    setOpen(false);
                  }}
                  className={`flex w-full items-start gap-2 px-3 py-2 text-left text-sm hover:bg-slate-50 ${
                    selectedSite?.id === site.id ? 'bg-blue-50' : ''
                  }`}
                >
                  <Check
                    size={14}
                    className={`mt-1 flex-shrink-0 ${
                      selectedSite?.id === site.id
                        ? 'text-blue-600'
                        : 'text-transparent'
                    }`}
                  />
                  <div className="min-w-0 flex-1">
                    <p className="truncate font-medium text-slate-900">
                      {site.name}
                    </p>
                    <p className="truncate text-xs text-slate-500">
                      {site.customDomain ?? direccionMostrable(site.slug)}
                    </p>
                    <p
                      className={`mt-0.5 inline-block rounded px-1.5 py-0.5 text-[10px] font-medium uppercase ${
                        site.status === 'active'
                          ? 'bg-emerald-100 text-emerald-700'
                          : site.status === 'pending_dns'
                            ? 'bg-amber-100 text-amber-700'
                            : 'bg-slate-100 text-slate-600'
                      }`}
                    >
                      {site.status}
                    </p>
                  </div>
                </button>
              </li>
            ))}
            <li className="border-t border-slate-200">
              <button
                type="button"
                onClick={() => {
                  setOpen(false);
                  navigate('/agencia/configuracion/sitios');
                }}
                className="flex w-full items-center gap-2 px-3 py-2 text-sm text-blue-600 hover:bg-blue-50"
              >
                <Plus size={14} />
                Gestionar sitios
              </button>
            </li>
          </ul>
        </>
      )}
    </div>
  );
};

export default SiteSwitcherDropdown;
